(function () {
  // Check if the current URL contains the "cid=CM-" parameter
  if (window.location.href.indexOf('cid=CM-') !== -1) {
    var cidValue = new URLSearchParams(window.location.search).get('cid');
    console.log('[CID Tracker] cid=CM- detected in URL | value: ' + cidValue);
    sessionStorage.setItem('arn-newsletter-subscribed', 'true');
  }
})();